<template>
  <div class="title">
    <h2>{{h2}}</h2>
    <h3 v-if="h3 !== ''">: {{h3}}</h3>
    <img src="@/assets/icons/icon-scrolldown.svg" />
  </div>
</template>

<script>
export default {
  props: {
    h2: String,
    h3: String,
  },
};
</script>

<style lang="scss" scoped>
.title {
  text-transform: uppercase;
  padding-bottom: 15px;
  position: relative;
  &::after {
    content: " ";
    display: block;
    height: 1px;
    transform: scaleY(-1) rotate(180deg);
    background-image: linear-gradient(
      270deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  h2,
  h3 {
    display: inline-block;
    vertical-align: bottom;
  }
}
h2 {
  font-size: 1.5em;
  color: #ff5100;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1.6em;
  margin-right: 5px;
}
h3 {
  font-size: 1.5em;
  letter-spacing: 0;
  line-height: 1.6em;
  color: #fff;
}
img {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-100%);
}
@media (min-width: 999px) {
  img {
    display: none;
  }
}
</style>